// extracted by mini-css-extract-plugin
export default {"default-warranty":"rules_default-warranty__MpvAx","ant-input":"rules_ant-input__2jWr+","ant-btn":"rules_ant-btn__6vloy"};